function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 17">
      <path fill="currentColor" d="M7 15v-4.5h3V15h4V9h2L8.5 2 1 9h2v6h4z" />
    </svg>
  );
}

export default Icon;
